import { straightRun } from "./path";
function archNotch(path, { axleX, hubY, radius, edgeY }) {
  const edgeAboveHub = edgeY - hubY;
  if (Math.abs(edgeAboveHub) >= radius) return false;
  const halfChord = Math.sqrt(radius ** 2 - edgeAboveHub ** 2);
  straightRun(path, axleX - halfChord, edgeY);
  const left = Math.atan2(edgeAboveHub, -halfChord);
  const start = left < 0 ? left + Math.PI * 2 : left;
  const end = Math.atan2(edgeAboveHub, halfChord);
  path.absarc(axleX, hubY, radius, start, end, true);
  return true;
}
export {
  archNotch
};
